import { schemaDiscriminator as e } from "./discriminator-metadata.js";
import { REQUEST_BODY_COMPOSITION_INDEX_SYMBOL as t } from "./request-body-composition-index.js";
import { partitionAllOfCompositions as n } from "./helpers/partition-all-of-compositions.js";
import { getCycleKey as r } from "./helpers/schema-cycle.js";
import { useLocalization as i } from "./localization/index.js";
import { getDiscriminatorValues as a } from "./helpers/get-discriminator-values.js";
import { getSchemaType as o } from "./helpers/get-schema-type.js";
import { getModelNameWithArray as s } from "./helpers/schema-name.js";
import c from "./SchemaGlyphPuck.vue.js";
import l from "./SchemaRailPanel.vue.js";
import u from "./Schema.vue.js";
import { Fragment as d, computed as f, createBlock as p, createCommentVNode as m, createElementBlock as h, createElementVNode as g, createTextVNode as _, createVNode as v, defineComponent as y, inject as b, normalizeClass as x, openBlock as S, ref as C, renderList as w, resolveComponent as T, toDisplayString as E, unref as D, watch as O, withCtx as k } from "vue";
import { ScalarListbox as A } from "@scalar/components/listbox";
import { ScalarIconCaretUpDown as j } from "@scalar/icons";
import { isDefined as M } from "@scalar/helpers/array/is-defined";
import { resolve as N } from "@scalar/workspace-store/resolve";
//#region src/schema/SchemaComposition.vue?vue&type=script&setup=true&lang.ts
var P = { class: "property-rule [.children+&]:mt-1.5!" }, F = {
	class: "composition-selector composition-selector--tree group/tree-control font-code relative flex w-fit max-w-full cursor-pointer items-start gap-1.5 py-1 text-sm",
	type: "button"
}, I = { class: "text-c-1 shrink-0 [font-weight:var(--scalar-bold)] whitespace-nowrap" }, L = ["title"], R = {
	key: 0,
	class: "text-red"
}, z = /*@__PURE__*/ y({
	__name: "SchemaComposition",
	props: {
		composition: {},
		discriminator: {},
		name: {},
		schema: {},
		level: {},
		depth: { default: 0 },
		compact: {
			type: Boolean,
			default: !1
		},
		hideHeading: {
			type: Boolean,
			default: !1
		},
		hideModelNames: { type: Boolean },
		breadcrumb: {},
		eventBus: {},
		options: {},
		schemaContext: {},
		compositionPath: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(y) {
		let z = y, { translate: B } = i(), V = f(() => z.composition === "allOf" ? n(z.schema).segments : []), H = f(() => [z.schema[z.composition]].flat().map((e) => ({
			value: N.schema(e),
			original: e
		})).filter((e) => M(e.value))), U = f(() => H.value.map((t, n) => {
			let r = N.schema(t.original), i = (s(r)?.label ?? o(r)) || B("schema.schema"), c = (z.schema.discriminator ?? z.discriminator)?.mapping, l = a(r.$ref, c), u = r.discriminator?.[e]?.value, d = l.length ? l : u === void 0 ? [] : [u];
			return {
				id: String(n),
				label: d.length && d.join(", ") !== i ? `${d.join(", ")} · ${i}` : i
			};
		})), W = f(() => z.compositionPath?.length ? [...z.compositionPath, z.composition].join(".") : ""), G = b(t, void 0), K = f(() => {
			if (z.schemaContext !== "requestBody" || !G?.value || !W.value) return 0;
			let e = G.value[W.value];
			return typeof e != "number" || Number.isNaN(e) ? 0 : Math.max(0, Math.min(e, U.value.length - 1));
		}), q = C();
		O([U, K], ([e, t]) => {
			(!q.value || !e.some((e) => e.id === q.value?.id)) && (q.value = e[t] ?? e[0]);
		}, { immediate: !0 });
		let J = (t) => z.schema[e]?.inheritedVariants ? B("schema.variants") : B(`schema.${t}`), Y = f(() => H.value[Number(q.value?.id ?? "0")]?.value), X = f(() => {
			let t = Y.value?.discriminator;
			return t?.[e] ? t : z.discriminator;
		}), Z = f(() => z.schemaContext === "requestBody" && z.compositionPath?.length === 1), Q = f(() => r(H.value[Number(q.value?.id ?? "0")]?.original)), $ = C(!!z.options.expandAllSchemaProperties);
		return G && z.schemaContext === "requestBody" && W.value && O(q, (e) => {
			let t = e ? Number(e.id) : 0;
			Number.isNaN(t) || (G.value = {
				...G.value,
				[W.value]: t
			});
		}, { immediate: !0 }), (e, t) => {
			let n = T("SchemaComposition", !0);
			return S(), h("div", P, [z.composition === "allOf" ? (S(!0), h(d, { key: 0 }, w(V.value, (e, t) => (S(), h(d, { key: t }, [e.kind === "object" ? (S(), p(u, {
				key: 0,
				breadcrumb: y.breadcrumb,
				compact: y.compact,
				compositionPath: y.compositionPath,
				depth: y.depth,
				discriminator: y.schema.discriminator ?? y.discriminator,
				eventBus: y.eventBus,
				expansion: y.expansion,
				hideDescription: Z.value,
				hideHeading: y.hideHeading,
				hideModelNames: y.hideModelNames,
				level: y.level + 1,
				name: y.name,
				noncollapsible: !0,
				options: y.options,
				schema: e.schema,
				schemaContext: y.schemaContext,
				scrollTargetId: y.scrollTargetId,
				specificationExtension: y.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideDescription",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : (S(), p(n, {
				key: 1,
				breadcrumb: y.breadcrumb,
				compact: y.compact,
				composition: e.composition,
				compositionPath: [...y.compositionPath ?? [], String(e.choiceIndex)],
				depth: y.depth,
				eventBus: y.eventBus,
				expansion: y.expansion,
				hideHeading: y.hideHeading,
				hideModelNames: y.hideModelNames,
				level: y.level,
				options: y.options,
				schema: e.value,
				schemaContext: y.schemaContext,
				scrollTargetId: y.scrollTargetId,
				specificationExtension: y.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"composition",
				"compositionPath",
				"depth",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			]))], 64))), 128)) : (S(), p(l, {
				key: 1,
				class: "composition-panel composition-panel--tree mt-1 mb-0.5",
				depth: y.depth + 1
			}, {
				default: k(() => [v(D(A), {
					modelValue: q.value,
					"onUpdate:modelValue": t[0] ||= (e) => q.value = e,
					class: "w-fit max-w-full min-w-40",
					options: U.value
				}, {
					default: k(() => [g("button", F, [
						v(c, {
							anchor: "line",
							class: "composition-selector-icon mt-1"
						}, {
							default: k(() => [v(D(j))]),
							_: 1
						}),
						g("span", I, E(J(z.composition)), 1),
						t[2] ||= g("span", {
							"aria-hidden": "true",
							class: "text-c-3 shrink-0"
						}, "·", -1),
						g("span", {
							class: x(["composition-selector-label text-c-1 min-w-0 truncate [font-weight:var(--scalar-bold)]", { "line-through": Y.value?.deprecated }]),
							title: q.value?.label || D(B)("schema.schema")
						}, E(q.value?.label || D(B)("schema.schema")), 11, L),
						Y.value?.deprecated ? (S(), h("div", R, E(D(B)("schema.deprecated")), 1)) : m("", !0)
					])]),
					_: 1
				}, 8, ["modelValue", "options"]), !$.value && y.level > 2 ? (S(), h("button", {
					key: 0,
					class: "composition-details-toggle group/tree-control font-code text-c-1 relative flex w-fit cursor-pointer items-center py-1.5 text-sm font-normal",
					type: "button",
					onClick: t[1] ||= (e) => $.value = !0
				}, [v(c), _(" " + E(D(B)("schema.showSchemaDetails")), 1)])) : (S(), p(u, {
					key: q.value?.id ?? "0",
					breadcrumb: y.breadcrumb,
					compact: y.compact,
					compositionPath: y.compositionPath,
					cycleKey: Q.value,
					depth: y.depth + 1,
					discriminator: X.value,
					eventBus: y.eventBus,
					expansion: y.expansion,
					hideHeading: y.hideHeading,
					hideModelNames: y.hideModelNames,
					level: y.level + 1,
					name: y.name,
					noncollapsible: !0,
					options: y.options,
					schema: Y.value,
					schemaContext: y.schemaContext,
					scrollTargetId: y.scrollTargetId,
					specificationExtension: y.specificationExtension
				}, null, 8, [
					"breadcrumb",
					"compact",
					"compositionPath",
					"cycleKey",
					"depth",
					"discriminator",
					"eventBus",
					"expansion",
					"hideHeading",
					"hideModelNames",
					"level",
					"name",
					"options",
					"schema",
					"schemaContext",
					"scrollTargetId",
					"specificationExtension"
				]))]),
				_: 1
			}, 8, ["depth"]))]);
		};
	}
});
//#endregion
export { z as default };

//# sourceMappingURL=SchemaComposition.vue_vue_type_script_setup_true_lang.js.map